import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResponseInterface } from '../interfaces/response';
import { UserType } from '../enums/constants';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class ContactAddressService {
  address: any = null;
  usertype: UserType = null;

  constructor(
    private http: HttpClient,
    private userService: UserService
  ) {
    this.usertype = this.userService.user.usertype;
  }

  addAddress(reqparams, vaultUserId, responseInterface: ResponseInterface<any>) {
    const route = this.usertype === UserType.ADMIN
      ? `/api/admin/contact-address/add/${vaultUserId}`
      : '/api/contact-address/add';
    return this.http.post<any>(route, reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getAddress(reqparams, responseInterface: ResponseInterface<any>) {
    return this.http.post<any>('/api/contact-address', reqparams).subscribe(
      (res: any) => {
        responseInterface.getResult(res);
      },
      (err) => {
        responseInterface.getError(err);
      }
    );
  }

  getAddressForUser(reqparams): Promise<any> {
    return this.http
      .post<any>('/api/contact-address/user', reqparams)
      .toPromise();
  }

  editAddress(reqparams, vaultUserId, responseInterface: ResponseInterface<any>) {
    const route = this.usertype === UserType.ADMIN
      ? `/api/admin/contact-address/edit/${vaultUserId}`
      : '/api/contact-address/edit';
    return this.http
      .post<any>(route, reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  deleteAddress(reqparams, responseInterface: ResponseInterface<any>) {
    const route = this.usertype === UserType.ADMIN
      ? '/api/admin/contact-address/delete'
      : '/api/contact-address/delete';
    return this.http
      .post<any>(route, reqparams)
      .subscribe(
        (res: any) => {
          responseInterface.getResult(res);
        },
        (err) => {
          responseInterface.getError(err);
        }
      );
  }

  getAddressForContact(reqparams): Promise<any> {
    return this.http
      .post<any>('/api/contact-address/contact', reqparams)
      .toPromise();
  }
}
